<!-- Overall family member container, will house all the components to make up the view -->
<div class="bulb-familymember-view row small-collapse">

    <!-- Angular component that will house the family members activity feed, displaying what they have created
      and liked etc... -->
    <bulb-familymember-activity-feed [parent]="parent" [familyMembers]="familyMembers"></bulb-familymember-activity-feed>

    <!-- Angular component that will house the family members container and will display all the connected
      family members: -->
    <connected-family-members [familyMembers]="familyMembers" *ngIf="activities.length > 0"></connected-family-members>
</div>
